import { hasNoElements } from "./Array";
import { isNullOrWhiteSpace } from "./String";

enum ProjectCookieType {
  Load,
  Since
}

export class ProjectCookie {
  cookie: string;

  type: ProjectCookieType;

  id?: string;

  idList?: string[];

  requestOn?: string;

  modifiedOn?: string;

  createdOn?: string;

  constructor(cookie: string) {
    if (isNullOrWhiteSpace(cookie)) {
      return;
    }

    this.cookie = cookie;

    const parts = cookie.split(`|`);
    if (parts[0] === `since`) {
      this.parseSince(parts);
      return;
    }

    this.parseLoad(parts);
  }

  parseLoad(parts: string[]) {
    const [, id, modifiedOn, createdOn, requestOn, ...idList] = parts;
    this.type = ProjectCookieType.Load;
    this.id = id;
    this.modifiedOn = modifiedOn;
    this.createdOn = createdOn;
    this.requestOn = requestOn;
    this.idList = idList ?? [];
  }

  parseSince(parts: string[]) {
    const [, requestOn, ...idList] = parts;
    this.type = ProjectCookieType.Since;
    this.requestOn = requestOn;
    this.idList = idList ?? [];
  }

  static fromStore(since: string, idList: string[]): ProjectCookie {
    const cookie = `since|${since}`;
    if (hasNoElements(idList)) {
      return new ProjectCookie(cookie);
    }
    return new ProjectCookie(`${cookie}|${idList.join(`|`)}`);
  }

  get sinceCookie() {
    const cookie = `since|${this.requestOn}`;
    if (hasNoElements(this.idList)) {
      return cookie;
    }

    return `${cookie}|${this.idList.join(`|`)}`;
  }

  get loadCookie() {
    return this.cookie;
  }
}
